(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-redeem-template"]) return;
  try {
    
$(function() {
    $('input[name="contact[shipping_method]"]').on('change', function() {
        var _self = $(this)
        console.log(_self)
    })
})

  } catch(e) { console.error(e); }
})();
})();
